import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";

import {
  Overlay,
  OverlayStyle,
} from "@faire/retailer/features/MarketplaceItems/Overlay/Overlay";

import * as styles from "./productTileOverlay.css";
import { ProductTileOverlayProps } from "./productTileOverlayProps";

export const ProductTileOverlay: React.FC<{
  data: ProductTileOverlayProps;
}> = ({ data }) => {
  const isSalesPaused = data.state === IProduct.State.SALES_PAUSED;
  const overlayStyle = () => {
    if (isSalesPaused) {
      return OverlayStyle.BACKORDERED;
    } else {
      return OverlayStyle.DARKENING;
    }
  };

  if (data.includeContainer) {
    return (
      <div className={styles.container}>
        <Overlay overlayStyle={overlayStyle()} />
      </div>
    );
  }
  return <Overlay overlayStyle={overlayStyle()} />;
};
